import { fetchUserData } from '../app/actions/actions_fetchUsers';
import _ from 'underscore';
//Auth middleware for redirect to login.gov
export const fetchMiddleWare = (store) => {
	return (next) => {
		return (action) => {
			const result = next(action);
			if (!_.isUndefined(result) && result.type) {
				switch (action.type) {
					case 'OFLC_REMOVE_USER_FROM_GROUP_SUCCESS':
						store.dispatch(fetchUserData());
						break;
					default:
						return;
				}
			}
		};
	};
};
